import moment from "moment";

export function isBeforeOrAtNoon(timeStr) {
    const time = moment(timeStr, "HH:mm:ss");
    const noon = moment("12:00:00", "HH:mm:ss");
    return time.isBefore(noon) || time.isSame(noon);
}

export function isAtNoonOrAfternoon(timeStr) {
    const time = moment(timeStr, "HH:mm:ss");
    const noon = moment("12:00:00", "HH:mm:ss");
    return !time.isBefore(noon);
}

export function getDayNameOutOfDate(date) {
    return moment(date).locale('en').format("dddd");
}



// WEBPACK FOOTER //
// ./src/helpers/planning.js